import { validatePhone } from 'utils/validation/validators'

type ValidatePhoneOnCustomFormParams = {
  phone: string
  isRequired?: boolean
}

export default function validatePhoneOnCustomForm({ phone, isRequired }: ValidatePhoneOnCustomFormParams) {
  let error = ''
  if (isRequired && !phone) {
    error = 'Este campo é obrigatório'
  }

  if (phone && !validatePhone(phone)) {
    error = 'Este telefone está incorreto.'
  }
  return error
}
